@if (item.FamilyName_s) {
  <div class="card card-item w-100 p-3">
    @if (previewVar?.[mode] && (templates$|async)?.[previewVar[mode]]) {
      <div class="preview-template"
      [innerHtml]="(templates$|async)[previewVar[mode]] | replaceTokensArray: {keys: item, previewVar: previewVar[mode]} | safe: 'html'"></div>
    } @else {
      @if (!sharedSvc.isMobileMode()) {
        <img product-image
          [product]="item"
          [size]="'Med'"
          class="card-img-top img-responsive"
          >
        <div class="card-body p-0">
          <div class="family-details">
            <h4 class="card-title" translate>{{item.familyCardMainTitle}}</h4>
            <p class="card-text" translate>{{item.familyCardSecondaryTitle}}</p>
          </div>
        </div>
        <div class="card-footer border-top-0 bg-transparent p-0">
          <button class="link-appearance d-block" (click)="goToFamily()" translate>Multiple products options available</button>
          <button class="leaf-btn btn view-all" (click)="goToFamily()"
            [translateParams]="{X: numFound}"
          translate>View All X Products</button>
        </div>
      } @else {
        <img product-image
          [product]="item"
          [size]="'Med'"
          class="mobile-card-image card-img-top img-responsive"
          >
        <div class="mobile-card-content d-flex flex-column">
          <div class="card-body">
            <h4 class="card-title" translate>{{item?.familyCardMainTitle}}</h4>
            <p class="card-text" translate>{{item?.familyCardSecondaryTitle}}</p>
          </div>
          <div class="card-footer">
            <hr>
              <button class="link-appearance" (click)="goToFamily()" translate>Multiple products options available</button>
              <button class="leaf-btn btn view-all" (click)="goToFamily()"
                [translateParams]="{X: numFound}"
              translate>View All X Products</button>
            </div>
          </div>
        }
      }
    </div>
  }

